import { defineMessages } from 'react-intl';

/** The copy of "Up next" and "Plug is working" (design outreach-v2 s1-s6). */
export const upNextMessages = defineMessages({
  title: { id: 'app.outreach.upNext.title', defaultMessage: 'Up next' },
  suffixDay: {
    id: 'app.outreach.upNext.suffix.day',
    defaultMessage: '· {count, plural, one {# pitch goes} other {# pitches go}} out {day}',
  },
  suffixWriting: {
    id: 'app.outreach.upNext.suffix.writing',
    defaultMessage: '· {count, plural, one {# pitch} other {# pitches}} for {day}',
  },
  liveWriting: { id: 'app.outreach.upNext.live.writing', defaultMessage: 'Writing {done} of {count}' },
  liveSending: { id: 'app.outreach.upNext.live.sending', defaultMessage: 'Sending' },
  seeAll: { id: 'app.outreach.upNext.seeAll', defaultMessage: 'See all in People' },
  more: { id: 'app.outreach.upNext.more', defaultMessage: '{count, plural, one {# more} other {# more}} in People' },

  dayToday: { id: 'app.outreach.upNext.day.today', defaultMessage: 'today' },
  dayTomorrow: { id: 'app.outreach.upNext.day.tomorrow', defaultMessage: 'tomorrow' },
  dayOn: { id: 'app.outreach.upNext.day.on', defaultMessage: 'on {day}' },

  // the "when" column
  whenTheirs: { id: 'app.outreach.upNext.when.theirs', defaultMessage: '{day} {time} their time' },
  whenNow: { id: 'app.outreach.upNext.when.now', defaultMessage: 'Now · {time} their time' },
  whenYours: { id: 'app.outreach.upNext.when.yours', defaultMessage: '{time} yours' },
  whenFrom: { id: 'app.outreach.upNext.when.from', defaultMessage: '{day}, from {time} their time' },
  whenNoTime: { id: 'app.outreach.upNext.when.noTime', defaultMessage: 'Gets its time when it is ready' },
  dayTodayCap: { id: 'app.outreach.upNext.dayCap.today', defaultMessage: 'Today' },
  dayTomorrowCap: { id: 'app.outreach.upNext.dayCap.tomorrow', defaultMessage: 'Tomorrow' },

  // the state cell (s5b)
  stateWriting: { id: 'app.outreach.upNext.state.writing', defaultMessage: 'Plug is writing' },
  stateReview: { id: 'app.outreach.upNext.state.review', defaultMessage: 'Waits for you' },
  stateReady: { id: 'app.outreach.upNext.state.ready', defaultMessage: 'Ready' },
  stateScheduled: { id: 'app.outreach.upNext.state.scheduled', defaultMessage: 'Scheduled' },
  stateSending: { id: 'app.outreach.upNext.state.sending', defaultMessage: 'Sending now' },
  waitsForPlug: { id: 'app.outreach.upNext.waitsForPlug', defaultMessage: 'Waits for Plug' },
  inTime: { id: 'app.outreach.upNext.in', defaultMessage: 'in {time}' },

  // the foot
  footWarmup: {
    id: 'app.outreach.upNext.foot.warmup',
    defaultMessage:
      'Your mailbox is warming up (day {day} of {days}), so Plug sends {cap} a day. Your plan allows {rate}. The number grows as the mailbox warms up.',
  },
  footWriting: {
    id: 'app.outreach.upNext.foot.writing',
    defaultMessage: 'Plug writes each pitch for that one person. The subject line shows here when it is written.',
  },

  // the today card
  titleWriting: {
    id: 'app.outreach.upNext.today.writing',
    defaultMessage: '{count} picked · Plug writes their pitches',
  },
  titleLater: {
    id: 'app.outreach.upNext.today.later',
    defaultMessage: '{sent} out yet · {count} go out {day}',
  },
  subWriting: {
    id: 'app.outreach.upNext.today.subWriting',
    defaultMessage: 'They go out {day}, in the send window of each person’s time zone.',
  },
  subFirst: {
    id: 'app.outreach.upNext.today.subFirst',
    defaultMessage: 'First one at {theirs} their time ({yours} yours).',
  },
  plugWorking: {
    id: 'app.outreach.upNext.plug.working',
    defaultMessage: 'Plug is working. It checks new fits and picks the next {count} {day} at {time}.',
  },
  plugWorkingNoCount: {
    id: 'app.outreach.upNext.plug.workingNoCount',
    defaultMessage: 'Plug is working. It checks new fits and picks the next people {day} at {time}.',
  },

  // no planned pitch: the next pick (s4b)
  sentTitle: { id: 'app.outreach.upNext.sent.title', defaultMessage: 'Sent {day}' },
  sentCount: {
    id: 'app.outreach.upNext.sent.count',
    defaultMessage: '{count, plural, one {# person} other {# people}}',
  },
  nextPickLine: {
    id: 'app.outreach.upNext.next.line',
    defaultMessage: 'Next: Plug picks {count} more {day} at {time}',
  },
  nextPickLineNoCount: {
    id: 'app.outreach.upNext.next.lineNoCount',
    defaultMessage: 'Next: Plug picks the next people {day} at {time}',
  },
  nextPickSub: {
    id: 'app.outreach.upNext.next.sub',
    defaultMessage: 'It checks new fits before the pick. Their names show here right after it.',
  },
});
